export default "__VITE_ASSET__C702p98U__"